import { render, staticRenderFns } from "./inputTable.vue?vue&type=template&id=664c62fd&"
import script from "./inputTable.vue?vue&type=script&lang=js&"
export * from "./inputTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports